import styled, { keyframes, css } from 'styled-components';
import { ImSpinner11 } from 'react-icons/im';

const rotate360 = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Icon = styled(ImSpinner11)<{ $loading?: boolean }>`
  display: inline-block;
  vertical-align: middle;
  ${(props) => props.$loading && css`
    /* animation: ${rotate360} 1s cubic-bezier(0.4, 0, 0.2, 1) infinite; */
    animation: ${rotate360} 690ms linear infinite;
  `}
`;
